import AbstractModule from '../../AbstractModule';
import RouteBuilder from '../../RouteBuilder';
import pageNotFound from './PageNotFound.vue';

class PageNotFoundModule extends AbstractModule {
  getRoutes(): any[] {
    return new RouteBuilder()
      .path('/:catchAll(.*)')
      .component(pageNotFound)
      .title('page-not-found-title')
      .build(false);
  }
}

new PageNotFoundModule();
